import React, { PureComponent } from 'react';
import {connect} from 'react-redux';

import {dismissNotification} from 'actions/notifications';
import Notification from 'components/Notification';

class Notifications extends PureComponent{
    render(){
        const {notification} = this.props;
        if(!notification) return null;
        return (
            <div className="super-notification-container">
                <Notification type={notification.type} message={notification.message} onClose={this.props.dismissNotification}/>
            </div>
        )
    }
}

function mapStateToProps(state){
    return {notification:state.notification}
}

export default connect(mapStateToProps,{dismissNotification})(Notifications);


// WEBPACK FOOTER //
// ./src/containers/Notifications.js